var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center"}},[_c('iframe',{attrs:{"id":"ytplayer","type":"text/html","width":"1008","height":"567","src":_vm.embedUrl,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }